import z from 'zod';

export const NewsSchema = z.object({
	title: z
		.string()
		.min(1, { message: 'Title is required' })
		.max(100, { message: 'Title must be at most 100 characters' }),

	description: z
		.string()
		.min(1, { message: 'Description is required' })
		.max(140, { message: 'Description must be at most 140 characters' }),
	rich_text: z.string().min(1, { message: 'Content is required' }),
	image: z.union([
		z.string().nonempty(),
		z.any().refine((v) => v instanceof FileList && v.length > 0, {
			message: 'Image is required',
		}),
	]),
	institution_codes: z
		.array(
			z.object({
				value: z.string(),
				label: z.string(),
			})
		)
		.min(1, { message: 'Select at least one institution' }),
});
